import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-buy-now-tab',
  templateUrl: './salvage-buy-now-tab.component.html',
})
export class SalvageBuyNowTabComponent {
  @Input() context!: SalvageTabContext;
}
